function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPnc = function SvgPnc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee7623"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 23.8c1.8 0 3.4-.1 4.6-.4-2.4 1.4-7.3 4.3-16.8 9.8l-.5.3c-1.7 1-3.6 1.1-4.4.3-1.1-1.1-.5-3.8 1.5-7.3l1.8-3.3c.3.4.9.7 1.6.7h12.3v-.1h-.1zm-10.9-8.7c.3-.7.9-1 1.4-1.1l-1.8-3.3c-2.1-3.5-4-5.3-5.5-4.9-1.2.3-2 2-2 4v.7c-.1 11 0 16.6 0 19.4v.1c.3-1.2 1-2.6 1.8-4.2l6.1-10.7zm15.4 1.2-.5-.3c-9.4-5.5-14.3-8.4-16.8-9.7.9.9 1.7 2.2 2.7 3.7l6.2 10.6c.3.7.4 1.2.2 1.7h3.8c4 0 6.6-.9 7.1-2.4.1-1-1-2.5-2.7-3.6z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgPnc;